import { Breadcrumbs, ContentLayout } from 'components/Layout';
import { Authorization, ROLES } from 'lib/authorization';

export const VaultDetails = () => {
  return (
    <ContentLayout
      title="Vault details"
      end={
        <Authorization
          allowedRoles={[ROLES.ROOT_USER, ROLES.TRANSACTION_MANAGER]}
          forbiddenFallback={<div />}
        ></Authorization>
      }
      breadcrumbs={<Breadcrumbs />}
    >
      <div></div>
    </ContentLayout>
  );
};
